export default __webpack_public_path__ + "static/media/tres.f0b767cb.svg";